import { render, staticRenderFns } from "./TheSidebarListItem.vue?vue&type=template&id=380603b2"
import script from "./TheSidebarListItem.vue?vue&type=script&lang=js"
export * from "./TheSidebarListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports